import styled from '@xstyled/styled-components'

export const StyledContentEditableWrapper = styled.div({
  position: 'relative',
  maxWidth: '100%'
})

const basePadding = 8
const hoverBorderWidth = 1

export const StyledContentEditable = styled.div<{ isReadonly?: boolean }>(
  props => ({
    padding: basePadding,
    paddingRight: 32,
    borderRadius: 4,
    fontSize: 24,
    fontWeight: 700,
    minWidth: 205,
    lineHeight: '133%',
    overflow: 'hidden',
    maxWidth: '100%',
    wordWrap: 'break-word',
    cursor: 'text',
    border: `${hoverBorderWidth}px solid transparent`,
    transition: 'all 150ms ease-in',
    '&:not(:empty)': {
      minWidth: 5,
      paddingRight: basePadding
    },
    '&:empty::before': {
      content: 'attr(placeholder)',
      color: props.theme.colors.grey.l2
    },
    '&+div': {
      opacity: 1,
      visibility: 'visible',
      transitionProperty: 'all',
      transitionDuration: '150ms',
      transitionTimingFunction: 'ease-in'
    },
    '&:not(:empty)+div': {
      opacity: 0,
      visibility: 'hidden'
    }
  }),
  props =>
    !props.isReadonly && {
      '&:hover': {
        borderColor: props.theme.colors.grey.l2
      },
      '&:focus-visible': {
        outline: 'none',
        borderColor: props.theme.colors.primary.base,
        boxShadow: `0 0 0 1px ${props.theme.colors.primary.base}`
      }
    }
)

export const StyledIconWrapper = styled.div({
  position: 'absolute',
  display: 'flex',
  top: '50%',
  transform: 'translateY(-50%)',
  right: 8,
  color: 'grey.d1',
  svg: {
    width: 16,
    height: 16
  }
})
